import { useContext } from 'react'
import get from 'lodash/get'

import { FnaContext } from '../../../context'
import { ASSESSMENT_TYPE } from '../../../reducer'
import { sumSelectedRiskProducts } from '../../../utils'

export const buildInitialValues = () => {
  const {
    state: {
      fna: {
        [ASSESSMENT_TYPE.DISABILITY_COVER]: assessment
      },
      riskProducts,
    }
  } = useContext(FnaContext)

  const risk_productables_attributes = get(assessment, 'risk_productables', [])

  return {
    existing_cover: get(assessment, 'existing_cover', 0),
    lifestyle_adjustment_expenses: get(assessment, 'lifestyle_adjustment_expenses', 0),
    total_immediate_expenses: get(assessment, 'total_immediate_expenses', 0),
    total_liabilities_expenses: get(assessment, 'total_liabilities_expenses', 0),
    total_from_selected_risk_products: sumSelectedRiskProducts(riskProducts, risk_productables_attributes),
    liabilitiables_attributes: get(assessment, 'liabilitiables', []),
    assetables_attributes: get(assessment, 'assetables', []),
    risk_productables_attributes,
  }
}
